<template>
  <div class="centerx sidebar">
    <vs-sidebar position-right parent="body" default-index="1" class="sidebarx" v-model="active">
      <div v-html="this.content" class="content" :class="this.className"></div>
    </vs-sidebar>
  </div>
</template>

<script>
export default {
  data()  {
      return {
        active: false,
        title: "",
        content: "",
        className : "",
        evaluations: []
      }
  },
  methods: {
    toggle(title, urlBody, evaluations) {
      this.evaluations = evaluations;
      let item_ids = this.evaluations.map(function(item) {return item.id});
      let dataPopup = this;
      axios.get(urlBody+"&evaluation_ids[]="+item_ids)
      .then(function (response) {
          dataPopup.title = title;
          dataPopup.content= response.data;
          dataPopup.active = true;

        });
    }
  }
}
</script>
